import { ReactElement } from 'react';

import { AppointmentStatus } from '@dreryk/egabinet-appointment-frontend-api';

import {
   appendTestableElementAttributes,
   IconFillColor,
   ReservationApprovedIcon,
   ReservationNotApprovedIcon,
   StyledFlex,
} from '@dreryk/react-components';

import { AppointmentDetailsInfoItem } from '../AppointmentDetailsInfoItem';
import { calendarTranslationKeys } from '../../../../../../translations';

import { AppointmentConfirmationStatusToggle } from './AppointmentConfirmationStatusToggle';

const t = calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab;

type AppointmentConfirmationStatusInfoItemProps = {
   confirmed: boolean;
   appointmentId: number;
   appointmentStatus: AppointmentStatus;
};

export const AppointmentConfirmationStatusInfoItem = (
   props: AppointmentConfirmationStatusInfoItemProps
): ReactElement => {
   return (
      <StyledFlex
         justifyContent={'space-between'}
         alignItems={'center'}
         {...appendTestableElementAttributes('appointmentConfirmationStatus')}
      >
         <AppointmentDetailsInfoItem
            testId={'appointmentConfirmationStatus'}
            icon={props.confirmed ? <ReservationApprovedIcon /> : <ReservationNotApprovedIcon />}
            iconFillColor={props.confirmed ? IconFillColor.SUCCESS : IconFillColor.BACKGROUND}
            content={props.confirmed ? t.confirmed : t.notConfirmed}
            description={t.appointmentConfirmationStatus}
         />
         {props.appointmentStatus === 'REGISTERED' ? (
            <AppointmentConfirmationStatusToggle
               initialConfirmed={props.confirmed}
               appointmentId={props.appointmentId}
            />
         ) : null}
      </StyledFlex>
   );
};
